export default {
  Auth: {
    region: "us-west-2",
    identityPoolId: "us-west-2:a8d82d55-f591-4d37-840c-565b66838608",
    userPoolId: "us-west-2_B5RHObHWG",
    userPoolWebClientId: "2bur0648g38b7uilhe3n37im6r",
  },
  API: {
    endpoints: [
      {
        name: "ScoringData",
        endpoint:
          "https://lambda.us-west-2.amazonaws.com/2015-03-31/functions/ts-scoring-api-prod-mobileData/invocations",
        service: "lambda",
        region: "us-west-2",
      },
      {
        name: "AllLoans",
        endpoint:
          "https://lambda.us-west-2.amazonaws.com/2015-03-31/functions/ts-scoring-api-prod-mobileAllLoans/invocations",
        service: "lambda",
        region: "us-west-2",
      },
      {
        name: "SingleLoan",
        endpoint:
          "https://lambda.us-west-2.amazonaws.com/2015-03-31/functions/ts-scoring-api-prod-mobileSingleLoan/invocations",
        service: "lambda",
        region: "us-west-2",
      },
      {
        name: "InviteReference",
        endpoint:
          "https://lambda.us-west-2.amazonaws.com/2015-03-31/functions/ts-scoring-api-prod-getReferenceFromInvite/invocations",
        service: "lambda",
        region: "us-west-2",
      },
      {
        name: "ExpireMobileInvite",
        endpoint:
          "https://lambda.us-west-2.amazonaws.com/2015-03-31/functions/ts-scoring-api-prod-expireMobileInvite/invocations",
        service: "lambda",
        region: "us-west-2",
      },
      {
        name: "RunIntegration",
        endpoint:
          "https://lambda.us-west-2.amazonaws.com/2015-03-31/functions/ts-integrations-prod-runIntegration/invocations",
        service: "lambda",
        region: "us-west-2",
      },
      {
        name: "SkipBanking",
        endpoint:
          "https://lambda.us-west-2.amazonaws.com/2015-03-31/functions/ts-scoring-api-prod-mobileSkipBanking/invocations",
        service: "lambda",
        region: "us-west-2",
      },
      {
        name: "GetTrustStartPublicConfigWithCreds",
        endpoint:
          "https://lambda.us-west-2.amazonaws.com/2015-03-31/functions/ts-scoring-api-prod-getTrustStartPublicConfigWithCreds/invocations",
        service: "lambda",
        region: "us-west-2",
      },
      {
        name: "SmartConsentPrefill",
        endpoint:
          "https://lambda.us-west-2.amazonaws.com/2015-03-31/functions/ts-smartconsent-prod-prefill/invocations",
        service: "lambda",
        region: "us-west-2",
      },
      {
        name: "SmartConsentLeads",
        endpoint:
          "https://lambda.us-west-2.amazonaws.com/2015-03-31/functions/ts-smartconsent-prod-leads/invocations",
        service: "lambda",
        region: "us-west-2",
      },
      {
        name: "StoreBankingEvents",
        endpoint:
          "https://lambda.us-west-2.amazonaws.com/2015-03-31/functions/ts-smartconsent-prod-storeBankingEvents/invocations",
        service: "lambda",
        region: "us-west-2",
      },
      {
        name: "TrustStartDealerIbvRequest",
        endpoint:
          "https://lambda.us-west-2.amazonaws.com/2015-03-31/functions/ts-scoring-api-prod-trustStartDealerIbvRequest/invocations",
        service: "lambda",
        region: "us-west-2",
      },
      {
        name: "TrustStartFindScoringRequest",
        endpoint:
          "https://lambda.us-west-2.amazonaws.com/2015-03-31/functions/ts-scoring-api-prod-trustStartFindScoringRequest/invocations",
        service: "lambda",
        region: "us-west-2",
      },
      {
        name: "TrustStartStatus",
        endpoint:
          "https://lambda.us-west-2.amazonaws.com/2015-03-31/functions/ts-scoring-api-prod-trustStartStatus/invocations",
        service: "lambda",
        region: "us-west-2",
      },
      {
        name: "ChatAPI",
        endpoint:
          "https://lambda.us-west-2.amazonaws.com/2015-03-31/functions/ts-chat-prod-httpChat/invocations",
        service: "lambda",
        region: "us-west-2",
      },
      {
        name: "Auth",
        endpoint:
          "https://lambda.us-west-2.amazonaws.com/2015-03-31/functions/ts-smartconsent-prod-auth/invocations",
        service: "lambda",
        region: "us-west-2",
      },
      {
        name: "DataProviderList",
        endpoint:
          "https://lambda.us-west-2.amazonaws.com/2015-03-31/functions/ts-smartconsent-prod-dataProviderList/invocations",
        service: "lambda",
        region: "us-west-2",
      },
      {
        name: "Consent",
        endpoint:
          "https://lambda.us-west-2.amazonaws.com/2015-03-31/functions/ts-smartconsent-prod-consent/invocations",
        service: "lambda",
        region: "us-west-2",
      },
    ],
  },
  AppSync: {
    url: "https://kki2ezlsmnebriallty6dq3cne.appsync-api.us-west-2.amazonaws.com/graphql",
    region: "us-west-2",
    auth: {
      type: "AWS_IAM",
    },
  },
};
